// Session State
// Current session state (not persisted)

export function createInitialState() {
  return {
    messages: [],
    loading: false,
    initialized: false,
    selectedElement: null,
    styleIndex: {}
  };
}

export const SessionAction = {
  SET_MESSAGES: 'SET_MESSAGES',
  ADD_MESSAGE: 'ADD_MESSAGE',
  SET_LOADING: 'SET_LOADING',
  SET_INITIALIZED: 'SET_INITIALIZED',
  SET_SELECTED_ELEMENT: 'SET_SELECTED_ELEMENT',
  CLEAR_SELECTED_ELEMENT: 'CLEAR_SELECTED_ELEMENT',
  SET_STYLE_INDEX: 'SET_STYLE_INDEX',
  CLEAR_CHAT: 'CLEAR_CHAT'
};

export function sessionReducer(state, action) {
  switch (action.type) {
    case SessionAction.SET_MESSAGES:
      return { ...state, messages: action.payload };

    case SessionAction.ADD_MESSAGE:
      return { ...state, messages: [...state.messages, action.payload] };

    case SessionAction.SET_LOADING:
      return { ...state, loading: action.payload };

    case SessionAction.SET_INITIALIZED:
      return { ...state, initialized: action.payload };

    case SessionAction.SET_SELECTED_ELEMENT:
      return { ...state, selectedElement: action.payload };

    case SessionAction.CLEAR_SELECTED_ELEMENT:
      return { ...state, selectedElement: null };

    case SessionAction.SET_STYLE_INDEX:
      return { ...state, styleIndex: action.payload };

    case SessionAction.CLEAR_CHAT:
      return {
        ...state,
        messages: [],
        initialized: false,
        selectedElement: null
      };

    default:
      return state;
  }
}
